<template>
  <div v-title data-title="我的客户" class="myclient">
    <wv-tabs v-model="currentTab" @click="onClick">
      <wv-tab
        v-for="tab in tabs"
        :title="tab!='客户描述'?tab!='我的客户'?tab+'（'+MyVisitorTotal+'）':tab+'（'+MyclientTotal+'）':tab"
        :key="tab"
      ></wv-tab>
    </wv-tabs>
    <div
      @click="togglepopupVisible()"
      style="position: absolute;top: 10px;right: 5px; font-size:14px;color:#999;z-index:99999"
    >
      客户描述
      <img style="width:10px" src="../../assets/img/warn-jurassic.png" />
    </div>
    <wv-search-bar
      :autofocus="false"
      v-model="Keyword"
      @search="onSearch"
      @cancel="onCancel"
      :show="false"
      minContentHeight="0px"
      placeholder="请输入好友姓名"
    />
    <scroller
      :on-refresh="refresh"
      :on-infinite="infinite"
      style="padding-top: 90px;"
      ref="myScroller"
    >
      <div v-if="disType==1" class="page" :class="borwser!=''?'':'needtomargin-top'">
        <div
          class="weui-form-preview preview-item"
          v-for="(model,$index) in orderlist"
          :key="$index"
        >
          <wv-media-box
            :title="model.Name"
            :thumb="model.HeadImgUrl"
            :description="'浏览'+model.ProductViewNumber+' 个产品，浏览'+model.ProductViewCount+'次'"
          ></wv-media-box>
          <span
            style="position: absolute;top: 66px;left: 85px; font-size:14px;color:#999"
          >最近浏览时间：{{model.OperateTime}}</span>
        </div>
      </div>
      <div v-if="disType==2" class="page" :class="borwser!=''?'':'needtomargin-top'">
        <div
          class="weui-form-preview preview-item"
          v-for="(model,$index) in orderlist"
          :key="$index"
        >
          <wv-media-box
            :title="model.Name"
            :thumb="model.HeadImgUrl"
            :description="'购买'+model.BuyProductCount+' 个产品'"
          ></wv-media-box>
          <span
            style="position: absolute;top: 66px;left: 85px; font-size:14px;color:#999"
          >最近购买时间：{{model.OperateTime}}</span>
        </div>
      </div>
    </scroller>
    <wv-popup :visible.sync="popupVisible" :height="300">
      <p style="text-align:center;margin-top:20px;">客户描述</p>
      <p style="margin-top:20px;margin-left:10px;font-size:1.2rem">访客</p>
      <p style="margin-top:10px;margin-left:10px;font-size:1.1rem">微信好友打开您分享的产品海报或者链接，即成为您的访客。</p>
      <p style="margin-top:20px;margin-left:10px;font-size:1.2rem">客户</p>
      <p
        style="margin-top:10px;margin-left:10px;font-size:1.1rem"
      >微信好友打开您分享的产品海报或者链接，即成为您的访客，并且通过该海报或者链接下单，即成为我的客户。</p>
    </wv-popup>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";

export default {
  name: "myclient",
  data: function() {
    return {
      borwser: this.GLOBAL.borwser,
      LoginType: -1,
      FirstInit: true, //首次加载（加载分页防止重复请求）
      logourl: thumb,
      Keyword: "",
      OrderType: null,
      ComboTypes: [],
      formset: [],
      PageSize: 5,
      PageNum: 1,
      TotalCount: "",
      orderlist: [],
      disType: 2,
      currentTab: 1,
      tabs: ["我的访客", "我的客户"],
      popupVisible: false,
      MyVisitorTotal: "",
      MyclientTotal: ""
    };
  },
  computed: {
    filterResult() {
      return this.defaultResult.filter(value =>
        new RegExp(this.value, "i").test(value)
      );
    }
  },
  created: function() {
    this.Initmyclient(0);
  },
  methods: {
    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    Initmyclient: function(type) {
      var data = {
        Type: this.disType,
        Keyword: this.Keyword,
        PageSize: this.PageSize,
        PageNum: this.PageNum
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/login/getmydisinfopager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            this.TotalCount = this.formset.Page.Total;
            this.MyVisitorTotal = this.formset.MyVisitorTotal;
            this.MyclientTotal = this.formset.MyclientTotal;
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            } else {
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },

    onClick: function(index) {
      if (index + 1 <= 2) {
        this.$refs.myScroller.finishInfinite(false);
        this.disType = index + 1;
        this.onSearch();
      } else {
        this.popupVisible = !this.popupVisible;
      }
    },
    togglepopupVisible: function() {
      this.popupVisible = !this.popupVisible;
    },
    onSearch(val) {
      this.$store.commit("showLoading");
      this.PageNum = 1;
      // 自定义搜索处理
      this.Initmyclient(0);
    },
    onCancel(val) {
      // 自定义取消事件处理
    },

    //产品详情
    OrderDetail: function(guid) {
      if (this.OrderType == 1) {
        this.$router.push({
          path: "/page/orderdetail",
          query: {
            OrderGuid: guid
          }
        });
      }
    },

    refresh: function(done) {
      //下拉
      var self = this;
      setTimeout(function() {
        self.PageNum = 1;
        self.Initmyclient(0);
        done();
      }, 2000);
    },
    infinite: function(done) {
      var self = this;
      setTimeout(function() {
        if (self.FirstInit) {
          self.FirstInit = false;
          if (self.TotalCount == self.formset.List.length) {
            self.$refs.myScroller.finishInfinite(true);
            return;
          }
        }

        self.PageNum += 1;
        self.Initmyclient(1);
        done();
        if (self.formset.List.length == 0) {
          self.$refs.myScroller.finishInfinite(true);
          return;
        }
      }, 1000);
    },
    btnClose: function() {}
  }
};
</script>




<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
  padding: 8px 15px;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left_three {
  width: 33%;
  text-align: center;
  font-size: 0.9em;
  float: left;
  background-color: #fff;
}

.weui-cells {
  font-size: 14px;
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.red .weui-cell__ft {
  color: red;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 50px;
}

.myclient .wv-tabs--line[data-v-1ee385f4] {
  width: 80%;
}
</style>




// WEBPACK FOOTER //
// src/components/mydisinfo/myclient.vue